/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CancellationStatus,
  CancellationStatus$inboundSchema,
  CancellationStatus$outboundSchema,
} from "./cancellationstatus.js";

export type WebhookDataCancellationCreated = {
  cancellationID: string;
  transferID: string;
  status: CancellationStatus;
};

/** @internal */
export const WebhookDataCancellationCreated$inboundSchema: z.ZodType<
  WebhookDataCancellationCreated,
  z.ZodTypeDef,
  unknown
> = z.object({
  cancellationID: z.string(),
  transferID: z.string(),
  status: CancellationStatus$inboundSchema,
});
/** @internal */
export type WebhookDataCancellationCreated$Outbound = {
  cancellationID: string;
  transferID: string;
  status: string;
};

/** @internal */
export const WebhookDataCancellationCreated$outboundSchema: z.ZodType<
  WebhookDataCancellationCreated$Outbound,
  z.ZodTypeDef,
  WebhookDataCancellationCreated
> = z.object({
  cancellationID: z.string(),
  transferID: z.string(),
  status: CancellationStatus$outboundSchema,
});

export function webhookDataCancellationCreatedToJSON(
  webhookDataCancellationCreated: WebhookDataCancellationCreated,
): string {
  return JSON.stringify(
    WebhookDataCancellationCreated$outboundSchema.parse(
      webhookDataCancellationCreated,
    ),
  );
}
export function webhookDataCancellationCreatedFromJSON(
  jsonString: string,
): SafeParseResult<WebhookDataCancellationCreated, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WebhookDataCancellationCreated$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WebhookDataCancellationCreated' from JSON`,
  );
}
